import { GzSelectedListWebComponent } from './component/GzSelectedListWebComponent';

export { GzSelectedListWebComponent };
